import React from "react";
import PropTypes from "prop-types";

/**
 * Loading spinner overlay
 * https://github.com/loadingio/css-spinner/
 *
 * @param show
 * @param fullWidth
 * @returns {null|*}
 * @constructor
 */
export const Spinner = ({ show, fullWidth, className }: { show: boolean; fullWidth?: boolean; className?: string }) => {
  if (!show) {
    return null;
  }

  // The spinner is made up of a collection of divs that rotate around a core with different transition times.
  return (
    <div className={`spinner lds-ring ${fullWidth ? "width_full" : ""} ${className ?? ""}`} data-testid="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Spinner;
